// extracted by mini-css-extract-plugin
module.exports = {"container":"File_container__3EZDn","backButton":"File_backButton__1HKjp","infos":"File_infos__W9qes","description":"File_description__17XT5"};